export default __webpack_public_path__ + "static/media/closet1.dbd95dbf.jpg";